module.exports = __webpack_public_path__ + "static/media/add_icon.fafc5dbf.svg";